import axios from 'axios';

export class httpClient {
  init() {
    this.http = axios.create({
      baseURL: this.baseUrl,
    });
    this.simulation = false; // For testing purposes
  }

  simulate() {
    this.simulation = true;
    return this;
  }

  setHeader(key, value) {
    this.headers[key] = value;
    return this;
  }

  removeHeader(key) {
    if (this.headers[key]) delete this.headers[key];
    return this;
  }

  async transmit(
    service = '',
    body = {},
    method = 'GET',
    headers = {},
    transformer = undefined,
    callBack = undefined
  ) {
    let headerContent = {
      ...this.headers,
      ...headers,
    };
    // Just in case, add Content-Type header if not set
    if (!headerContent['Content-Type']) {
      headerContent['Content-Type'] = 'application/json';
    }
    // Assemble a query string
    const queryString = [];
    if (['GET', 'DELETE'].includes(method) && Object.entries(body).length) {
      for (const [key, value] of Object.entries(body)) {
        if (key) {
          queryString.push(`${key}=${value}`);
        }
      }
    }

    let transformed,
      response = null;
    try {
      let options = { headers: headerContent };
      if (!['GET', 'DELETE'].includes(method) && Object.entries(body).length) {
        options.data = body;
      }
      if (this.simulation) {
        console.log(
          `Simulating ${method} request to ${service} with body and headers:`,
          body,
          headerContent
        );
        return Promise.resolve({ data: { success: true } });
      }
      switch (method) {
        case 'GET':
          response = this.http.get(
            `${service}${queryString.length ? `?${queryString.join('&')}` : ''}`,
            options
          );
          break;
        case 'POST':
          response = this.http.post(service, body, options);
          break;
        case 'PUT':
          response = this.http.put(service, body, options);
          break;
        case 'PATCH':
          response = this.http.patch(service, body, options);
          break;
        case 'DELETE':
          //headerContent['Content-Type'] = 'application/x-www-form-urlencoded';
          response = this.http.delete(
            `${service}${queryString.length ? `?${queryString.join('&')}` : ''}`,
            options
          );
          break;
      }
      if (transformer) transformed = transformer(response, body, true) || undefined;
      return transformed || response;
    } catch (error) {
      if (callBack) transformed = callBack(error, body, false);
      return transformed || error;
    }
  }
  async post(service, body, callBack = undefined, transformer = undefined, headers = {}) {
    return await this.transmit(service, body, 'POST', headers, transformer, callBack);
  }

  async get(
    service,
    body = {},
    callBack = undefined,
    transformer = undefined,
    headers = {}
  ) {
    return await this.transmit(service, body, 'GET', headers, transformer, callBack);
  }

  async put(service, body, callBack = undefined, transformer = undefined, headers = {}) {
    return await this.transmit(service, body, 'PUT', headers, transformer, callBack);
  }

  async patch(
    service,
    body,
    callBack = undefined,
    transformer = undefined,
    headers = {}
  ) {
    return await this.transmit(service, body, 'PATCH', headers, transformer, callBack);
  }

  async delete(
    service,
    body = {},
    callBack = undefined,
    transformer = undefined,
    headers = {}
  ) {
    return await this.transmit(service, body, 'DELETE', headers, transformer, callBack);
  }
}

const http = () => new httpClient();
export default http;
